import { dataCaretDown } from 'dls-icons-data'
import { createIcon } from '../common'

const IconCaretDown = /*#__PURE__*/createIcon(dataCaretDown)
export default IconCaretDown
